import { z } from 'zod';
import { contentIdSchema } from '../rules/content-id.js';
/**
 * Стартовое снаряжение: «Choose A or B» из таблиц класса
 * и предыстории (SRD 5.2, с. 28–83).
 *
 * Единственное место этих таблиц, где источник прячет выбор в прозу.
 * Разложено в данные по той же причине, что и остальные выборы (D23):
 * визард показывает то, что объявила запись, а не список в коде.
 */
export const equipmentItemSchema = z.strictObject({
    /** Название как в источнике: «2 Daggers» → «Daggers», количество отдельно. */
    name: z.string().min(1),
    quantity: z.number().int().positive(),
    /**
     * Запись предмета, если она в импорте есть. `null` — предмета нет
     * отдельной записью («Spellbook», «Arrows»: в таблицах снаряжения
     * SRD их нет) либо позиция ссылается на выбор, сделанный выше
     * («Artisan’s Tools … chosen for the tool proficiency above»).
     */
    id: contentIdSchema.nullable(),
});
export const startingEquipmentSchema = z.strictObject({
    /** Формулировка выбора из источника: «Choose A or B». */
    prompt: z.string().min(1),
    options: z
        .array(z.strictObject({
        /** Буква варианта, как в источнике. */
        option: z.string().regex(/^[A-Z]$/),
        items: z.array(equipmentItemSchema),
        /** Золото варианта: «and 5 GP» либо «55 GP» целиком. */
        goldGp: z.number().nonnegative(),
    }))
        .min(1),
});
//# sourceMappingURL=starting-equipment.js.map